import "core-js/modules/es.array.concat.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-56da7650"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "text-align": "right",
    "margin": "0"
  }
};
var _hoisted_2 = {
  class: "d-flex align-items-center"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" Copier");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_button = _resolveComponent("el-button");

  var _component_inline_svg = _resolveComponent("inline-svg");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_ShareNetwork = _resolveComponent("ShareNetwork");

  var _component_el_popover = _resolveComponent("el-popover");

  var _directive_clipboard = _resolveDirective("clipboard");

  return _openBlock(), _createBlock(_component_el_popover, {
    trigger: "click",
    placement: "top",
    width: 600
  }, {
    reference: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "default", {}, undefined, true)];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        readonly: "readonly",
        type: "text",
        modelValue: _ctx.sharingURL,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.sharingURL = $event;
        })
      }, null, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        class: "active-copie ms-2 me-2",
        style: _normalizeStyle("color: ".concat(_ctx.color, "; border: 1px solid ").concat(_ctx.color))
      }, {
        default: _withCtx(function () {
          return [_hoisted_3];
        }),
        _: 1
      }, 8, ["style"])), [[_directive_clipboard, _ctx.sharingURL, "copy"], [_directive_clipboard, function () {
        return _ctx.ElNotification({
          title: 'Lien est copié',
          type: 'success'
        });
      }, "success"], [_directive_clipboard, function () {
        return _ctx.ElNotification({
          title: 'appreil non supporté',
          type: 'error'
        });
      }, "error"]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networks, function (network) {
        return _openBlock(), _createBlock(_component_ShareNetwork, {
          title: "Espace revétement",
          key: network.network,
          network: network.network,
          url: _ctx.sharingURL
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_button, {
              style: _normalizeStyle("color: ".concat(_ctx.color, "; border: 1px solid ").concat(_ctx.color)),
              class: "mx-2 me-2"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_el_icon, null, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_inline_svg, {
                      src: network.icon,
                      style: _normalizeStyle(network.style)
                    }, null, 8, ["src", "style"])];
                  }),
                  _: 2
                }, 1024)];
              }),
              _: 2
            }, 1032, ["style"])];
          }),
          _: 2
        }, 1032, ["network", "url"]);
      }), 128))])])];
    }),
    _: 3
  });
}